module.exports = __webpack_public_path__ + "img/mercado-pago.f6d9d8ac.svg";